import React, { useCallback, useEffect, useState } from "react";
import { fetchDmtLedgers } from "../api/ledgersApi";
import { formatAmount } from "../utils/formatAmount";
import { autoDateFormat } from "../utils/autoDateFormate";
import { useNotify } from "../context/NotifyContext";
import useSocketEvent from "../socket/useSocketEvent";
import { exportTable, LEDGER_EXPORT_COLUMNS } from "../utils/downloadExcel";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  useListingState,
  LEDGER_STATUS_OPTIONS,
} from "./listing";

const WalletLedger = () => {
  const { notify } = useNotify();
  const listing = useListingState({ sortBy: "date", sortDir: "desc" });
  const [totalPages, setTotalPages] = useState(1);
  const [ledgers, setMainWalletLedger] = useState([]);
  const [totalLedgers, setTotalbyAll] = useState(0);

  const fetch_ledgers = useCallback(async () => {
    try {
      const result = await fetchDmtLedgers(listing.query);
      if (result?.success) {
        const response = result?.data;
        setMainWalletLedger(response?.ledgers || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalbyAll(response?.pagination?.total || 0);
      } else {
        notify(result?.message || "Server Error", "error");
      }
    } catch (error) {}
  }, [listing.query, notify]);

  useEffect(() => {
    fetch_ledgers();
  }, [fetch_ledgers]);

  useSocketEvent("wallet_changed", fetch_ledgers);

  return (
    <div className="ds-card mt-4 text-xs">
      <ListingFilters
            onClear={listing.clearFilters}
        startDate={listing.startDate}
        endDate={listing.endDate}
        onStartDate={listing.setStartDate}
        onEndDate={listing.setEndDate}
        search={listing.search}
        onSearch={listing.setSearch}
        searchPlaceholder="Search"
        status={listing.status}
        onStatus={listing.setStatus}
        statusOptions={LEDGER_STATUS_OPTIONS}
        showApply
        onApply={fetch_ledgers}
        applyLabel="Search"
        onExport={() =>
          exportTable("main-wallet-ledger", LEDGER_EXPORT_COLUMNS, ledgers, notify)
        }
      />

      <div className="ds-table-wrap ds-scroll">
        <table className="ds-table ds-table-listing whitespace-nowrap">
          <thead>
            <tr>
              <SortableTh
                label="T. DATE"
                sortKey="date"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
              <th>REMARKS</th>
              <SortableTh
                label="DEBIT (₹)"
                sortKey="debit"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
              <SortableTh
                label="CREDIT (₹)"
                sortKey="credit"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
              <SortableTh
                label="BALANCE (₹)"
                sortKey="closingBalance"
                activeKey={listing.sortBy}
                direction={listing.sortDir}
                onSort={listing.toggleSort}
              />
            </tr>
          </thead>
          <tbody>
            {ledgers?.length > 0 ? (
              ledgers.map((item, index) => (
                <tr key={item?._id || index}>
                  <td className="whitespace-nowrap">{autoDateFormat(item?.date)}</td>
                  <td
                    className="whitespace-nowrap sm:whitespace-nowrap sm:max-w-[200px] sm:truncate cursor-pointer"
                    title={item?.narration || "Opening Balance"}
                  >
                    {item?.narration || "Opening Balance"}
                  </td>
                  <td>{formatAmount(item?.debit)}</td>
                  <td>{formatAmount(item?.credit)}</td>
                  <td>{formatAmount(item?.closingBalance)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-[var(--text-muted)]">
                  No Ledgers Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <ListingPagination
        page={listing.page}
        limit={listing.limit}
        total={totalLedgers}
        totalPages={totalPages}
        onPageChange={listing.setPage}
        onLimit={listing.setLimit}
      />
    </div>
  );
};

export default WalletLedger;
